module.exports = "### Hello World JSX\n\nBack to Hello World example\n\n- Another way to write element\n\n- Syntax called JSX\n\n- Built-in support\n\n- \"Why are you writing HTML inside JavaScript?\""


//////////////////
// WEBPACK FOOTER
// ./src/slides/06_hello_world_jsx/notes_1.md
// module id = 1495
// module chunks = 0